module.exports = __webpack_public_path__ + "static/media/empty_bonus.19c7fc38.svg";